
















































































































import Vue from "vue";
import Component from "vue-class-component";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import { ChangeUserPasswordCommand } from "@/api/AuthenticationApiClient";
import { LoadingSpinnerService, UserStore } from "@/store";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import PasswordStrengthIndicator from "@/views/auth/PasswordStrengthIndicator.vue";

@Component({
  name: "confirm-email",
  components: {
    FontAwesomeIcon,
    FontAwesomeLayers,
    PasswordStrengthIndicator
  }
})
export default class ConfirmEmail extends Vue {
  private alertService = new AlertService();
  private emailConfirmed: boolean = false;
  private userId: string | undefined;
  private confirmationToken: string | undefined;
  private passwordResetToken: string | undefined;
  private newPassword: string = "";
  private confirmPassword: string = "";
  private tokenExpired: boolean = false;

  $refs!: {
    passwordStrengthIndicator: PasswordStrengthIndicator;
  };

  async created() {
    this.confirmationToken = this.getTokenParam();
    this.userId = this.getUserIdParam();

    this.emailConfirmed = await this.checkEmailAlreadyConfirmed();
  }

  private async checkEmailAlreadyConfirmed(): Promise<boolean> {
    LoadingSpinnerService.Show("Checking your email address...");
    const apiClient = ApiFactory.CreateAuthClient();
    const confirmed = await apiClient.users_IsEmailConfirmed(this.userId);
    LoadingSpinnerService.Hide();
    return confirmed;
  }
  private async confirmEmail(): Promise<boolean> {
    const apiClient = ApiFactory.CreateAuthClient();
    try {
      const result = await apiClient.users_ConfirmEmail(
        this.userId,
        this.confirmationToken
      );
      if (result) {
        if (result.success) {
          this.passwordResetToken = result.token;
          return true;
        } else if (result.expired) {
          this.tokenExpired = true;
          return false;
        } else if (result.alreadyConfirmed) {
          this.emailConfirmed = true;
          return false;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "We couldn't confirm your email address, please try again."
      );
    }

    return false;
  }

  showValidationError(): boolean {
    return (
      this.newPassword.length > 0 &&
      this.confirmPassword.length > 0 &&
      !this.passwordsMatch()
    );
  }

  passwordsMatch(): boolean {
    if (this.newPassword === "") return false;
    else return this.newPassword === this.confirmPassword;
  }

  passwordIsValid(): boolean {
    const isValid = this.$refs.passwordStrengthIndicator
      ? this.$refs.passwordStrengthIndicator.IsValid
      : false;
    return isValid && this.passwordsMatch();
  }

  async onConfirmClicked(event: MouseEvent) {
    if (!this.$refs.passwordStrengthIndicator.IsValid) {
      return;
    }

    event.preventDefault();

    LoadingSpinnerService.Show("Creating your account...");
    if (!(await this.confirmEmail())) {
      LoadingSpinnerService.Hide();
      return;
    }

    const apiClient = ApiFactory.CreateAuthClient();

    var cmd = new ChangeUserPasswordCommand({
      userId: this.userId,
      token: this.passwordResetToken,
      password: this.newPassword
    });

    try {
      const result = await apiClient.users_RecoverPassword(cmd);
      if (result) {
        LoadingSpinnerService.Success("Account created successfully!");
        this.$router.push("/home");
      } else {
        LoadingSpinnerService.Failure(
          "Unable to save your password. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Unable to save your password. Please try again."
      );
    }
  }

  private getTokenParam(): string | undefined {
    const t = this.$route.query.token;
    if (t === undefined) {
      this.$router.push("/home");
    } else return t.toString();
  }

  private getUserIdParam(): string | undefined {
    const u = this.$route.query.UserId;
    if (u === undefined) {
      this.$router.push("/home");
    } else return u.toString();
  }

  private redirect(e: MouseEvent) {
    this.$router.push("/home");
    location.reload();
  }

  get companyLogo(): string {
    return UserStore.companyLogo;
  }
}
